import controller from './service-orders.controller';
import template from './service-orders.view.html';

let ServiceOrdersComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ServiceOrdersComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/payments-advances/service-orders/service-orders.component.js
 **/